import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#F25022",
			d: "M15.5 4.1H4.1v11.4h11.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#7FBA00",
			d: "M27.9 4.1H16.5v11.4h11.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00A4EF",
			d: "M15.5 16.5H4.1v11.4h11.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB900",
			d: "M27.9 16.5H16.5v11.4h11.4z"
		})
	]
});
export default SvgMicrosoftRegularIcon;
